// exports.BASE= 'https://ckx5q75nic.execute-api.us-east-1.amazonaws.com';
exports.BASE= 'https://is6fk569ih.execute-api.us-east-1.amazonaws.com';
exports.FRONTEND_URL = 'https://arborgold-atlas.arborgold.net';